import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/bonus-actions';
import { BonusActions } from '../constants';
import { IBonus } from 'src/types/bonus';

export interface BonusState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IBonus>;
    current: IBonus | null;
    currentFiles: any | null;
    exigentBonusStatus: any | null;
    exigentBonusStatusInProgress: boolean;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],

        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
    exigentBonusStatus: null,
    exigentBonusStatusInProgress: false,
};

export function bonuses(state: BonusState = initialState, action: Actions | any): BonusState {
    switch (action.type) {
        case requestType(BonusActions.GENERATE_BONUS):
            return { ...state, error: '', inProgress: true };
        case successType(BonusActions.GENERATE_BONUS):
            return { ...state, current: action.payload, inProgress: false };
        case failureType(BonusActions.GENERATE_BONUS):
            return { ...state, error: action.error, inProgress: false };

        case requestType(BonusActions.FETCH_BONUSES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(BonusActions.FETCH_BONUSES):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(BonusActions.FETCH_BONUSES):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(BonusActions.FETCH_BONUS):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(BonusActions.FETCH_BONUS):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(BonusActions.FETCH_BONUS):
            return { ...state, inProgress: false, error: action.error };

        case requestType(BonusActions.FETCH_EXIGENT_BONUS_STATUS):
            return { ...state, error: '', exigentBonusStatusInProgress: true, exigentBonusStatus: null };
        case successType(BonusActions.FETCH_EXIGENT_BONUS_STATUS):
            return { ...state, exigentBonusStatusInProgress: false, exigentBonusStatus: action.payload };
        case failureType(BonusActions.FETCH_EXIGENT_BONUS_STATUS):
            return { ...state, exigentBonusStatusInProgress: false, error: action.error?.message ?? 'Unknown error' };
        case BonusActions.RESET_EXIGENT_BONUS_STATUS:
            return { ...state, exigentBonusStatus: null, exigentBonusStatusInProgress: false };
        default:
            return state;
    }
}
